export default __webpack_public_path__ + "static/media/3031 cutlery side.7b3e6e15.png";